module.exports = __webpack_public_path__ + "odstraneni-tetovaze_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_3_before.jpg
// module id = 958
// module chunks = 0